import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhFiltersComponent } from '@shared/components/ph-filters/ph-filters.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { PhInputModule } from '@shared/components/ph-input/ph-input.module';
import { SortProjectsComponent } from './components/sort-projects/sort-projects.component';
import { SortRankingComponent } from '../../../layouts/default/layouts/guest/pages/ranking/components/sort-ranking/sort-ranking.component';
import { FilterContinentComponent } from './components/filter-continent/filter-continent.component';
import { FilterCategoryComponent } from './components/filter-category/filter-category.component';
import { FilterSearchComponent } from './components/filter-search/filter-search.component';
import { FormsModule } from '@angular/forms';
import { FilterFeaturedComponent } from './components/filter-featured/filter-featured.component';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HttpLoaderFactory } from 'src/app/app.functions';

@NgModule({
  declarations: [
    PhFiltersComponent,
    SortProjectsComponent,
    SortRankingComponent,
    FilterContinentComponent,
    FilterCategoryComponent,
    FilterSearchComponent,
    FilterFeaturedComponent,
  ],
  exports: [PhFiltersComponent, SortRankingComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
    }),
    PhInputModule,
    FormsModule,
    RouterModule,
  ],
  providers: [],
})
export class PhFiltersModule {}
